<template>
  <div>
    <v-card v-if="table">
      <vHideOrShowColumnsComponent
        :headers="headersProp"
        @column-clicked="hideOrShowSelectedColumns"
      ></vHideOrShowColumnsComponent>
      <v-card-title :style="getThemeStyle">
        {{ title }}
        <v-spacer></v-spacer>
        <v-text-field
          dark
          v-model="search"
          append-icon="mdi-magnify"
          :label="'Search ' + capitalizeFirstCharacter(table)"
          single-line
          hide-details
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="itemsPerPage"
      >
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import vHideOrShowColumnsComponent from "./vHideOrShowColumnsComponent.vue";
export default {
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
  },
  components: { vHideOrShowColumnsComponent },
  props: {
    table: {
      default: null,
    },
    title: {
      default: "Data Title",
    },
    items: {
      default: () => [],
    },
    headersProp: {
      default: () => [],
    },
    height: {
      default: "400px",
    },
    itemsPerPage: {
      default: 50,
    },
  },
  watch: {
    headersProp(newVal) {
      this.headers = newVal;
    },
  },
  mounted() {
    this.headers = this.headersProp;
  },
  data: () => ({
    search: "",
    headers: [],
    switchValue: false,
  }),
  methods: {
    capitalizeFirstCharacter(str) {
      return helpersJs.capitalizeFirstCharacter(str);
    },
  },
};
</script>

<style></style>
